import { Component, Input, OnInit } from '@angular/core';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import * as moment from 'moment';
import { Periodos } from '../periodos-envio/periodos-envio.component';

@Component({
  selector: 'app-calendario-visual',
  templateUrl: './calendario-visual.component.html',
  styleUrls: ['./calendario-visual.component.css']
})
export class CalendarioVisualComponent implements OnInit {
  startDate:Date;
  listaPeriodo: Periodos[]=[];
  @Input() valor;
  ff
  fi
  directoresArea
  directoresGenerales=null

  constructor() { }

  ngOnInit(): void {
    this.listaPeriodo=this.valor;
    this.startDate =this.listaPeriodo['fechaInicio_periodoEnvio'];
    this.fi=this.reformatDate(this.listaPeriodo['fechaInicio_periodoEnvio']);
    this.ff=this.reformatDate(this.listaPeriodo['fechaTermino_periodoEnvio']);
    let fechaDirArea=this.reformatDate(this.listaPeriodo['fechaTermino_periodoEnvio']);
    this.directoresArea=this.calcDir(fechaDirArea,2);
    this.directoresGenerales=this.calcDir(fechaDirArea,3)
  }


  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    if (view === 'month') {
        if(cellDate.getDay() !=0){ //val domingo
          if(cellDate.getDay() !=6){ //val sabado
            const date = cellDate.getDate();
            if((moment((cellDate))>=moment(this.fi)) && (moment((cellDate))<=moment(this.ff))){
              return 'envio';
            }
            if((moment((cellDate))>moment(this.ff)) && (moment((cellDate))<=moment(this.directoresArea))){
              return 'directoresArea';
            } 
            if((moment((cellDate))>moment(this.directoresArea)) && (moment((cellDate))<=moment(this.directoresGenerales))){
              return 'directoresGenerales';
            } 
            }
          }
    }
    return '';
  }

  reformatDate(date){
    let d = date.split("-");
    let dd1=d[2];
    let p = dd1.split("T");
    let dd=parseInt(p[0]) ;
    let mm=d[1]-1;
    let yyyy =d[0];
    let newDate=new Date(yyyy,mm,dd);
    return newDate;
  }

  calcDir(date,dias){
    let i=0;
      while (i<dias) {
        date.setTime(date.getTime()+24*60*60*1000); // añadimos 1 día
        if (date.getDay() != 6 && date.getDay() != 0)
        i++;  
      }
    let newDate2=new Date(date.getFullYear(),parseInt(date.getMonth()),date.getDate());
    return newDate2;
  }

}
